import React from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import { Field } from 'formik'
import Input from 'components/Forms/FormElements/Input'

const EventReminderTopic = ({ label, fieldName, placeholder = '' }) => {
    return (
        <Field
            name={fieldName}
            label={label}
            placeholder={placeholder}
            type="text"
            size="s"
            component={Input}
        />
    )
}

EventReminderTopic.propTypes = {
    label: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
}

export default withTranslationCustom('events')(EventReminderTopic)
